import { render, staticRenderFns } from "./matching.vue?vue&type=template&id=0f947681"
import script from "./matching.vue?vue&type=script&lang=js"
export * from "./matching.vue?vue&type=script&lang=js"
import style0 from "./matching.vue?vue&type=style&index=0&id=0f947681&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports